/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_AdInputs */



/**
* | output |
* | --- |
* | "Automatic AD/DV" |
*
* @param {Automatic_AdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_ad = /** @type {((inputs?: Automatic_AdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_AdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publicité automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Werbung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblicità automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическая АЦП")
	if (locale === "es") return /** @type {LocalizedString} */ ("AD automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动广告")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動広告")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित एडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Anúncio automático")
	return /** @type {LocalizedString} */ ("Automatic AD/DV")
});